<template>
  <v-card elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }}
            {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{ currentUser.roles[0].descripcion }}
          </h4>
          <v-divider class="mt-3"/>
          <div align="center" class="font-weight-bold mt-6">
            <h1 v-if="currentApelacion.toca">
              COMUNICADOS DEL TOCA
                {{ currentApelacion.toca.numero }}/{{ currentApelacion.toca.anio }}
                <span class="ml-n1" v-if="currentApelacion.toca.complemento">
                  -{{ currentApelacion.toca.complemento }}
                </span>
            </h1>
            <v-btn
              small
              class="white--text mt-n6"
              style="float: right;"
              color="#276090"
              @click="$router.push({ name:'MisDocumentos' })"
            ><v-icon class="mr-2">mdi-arrow-left</v-icon>IR A DOCUMENTOS
            </v-btn>
          </div>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-4">
          <v-toolbar color="#276090" dark dense>
            <v-toolbar-title class="text-uppercase font-weight-bold">
              apelación electrónica
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-divider></v-divider>
    </v-row>
    <v-card class="mb-5"><br>
      <ApelacionElectronica v-if="currentApelacion.hash"
        :hash="currentApelacion.hash"
        :sala_id="currentUser.sala_id"
      >
      </ApelacionElectronica>
      <v-col class="mb-0 pt-0">
        <v-card elevation=7>
          <v-toolbar color="#276090" dark dense>
            <v-toolbar-title class="text-uppercase font-weight-bold">
              Comunicados
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-list>
            <div
              class="mb-3 ml-8 mr-8"
              v-for="(comunicado, index) in listComunicados"
              :key="'envio_'+index"
            >
              <!-- DOCUMENTOS -->
              <div class="mt-6 mb-4 text-uppercase">
                <h3>TIPO:
                  <span
                  :style="comunicado.tipo_envio.nombre == 'Requerimiento' ? 'color: #4052B5' : ''">{{ comunicado.tipo_envio.nombre }}</span>
                  <v-btn
                    v-if="comunicado.vista_juez==2"
                    style="float: right;"
                    small
                    class="white--text"
                    color="#CDA652"
                    @click="addComunicado(comunicado)"
                  >AGREGAR DOCUMENTO</v-btn>
                  <v-btn
                    v-if="comunicado.vista_juez==2 && comunicado.envio_documentos.length"
                    style="float: right;"
                    small
                    class="white--text mr-1"
                    color="#276090"
                    @click="clickDarVista(comunicado), indexLoader=index"
                    :loading="index==indexLoader"
                    :disabled="indexLoader!=-1 || index==indexLoader"
                  >ENVIAR AL JUZGADO</v-btn>
                  <v-btn
                    v-if="comunicado.vista_juez==2 && !comunicado.envio_documentos.length"
                    style="float: right;"
                    small
                    class="white--text mr-1"
                    color="red"
                    @click="deleteComunicado(comunicado)"
                  >ELIMINAR</v-btn>
                </h3>
              </div>
              <div>
                <p>
                  <b>-NUM. OFICIO:</b> {{ comunicado.num_oficio }}
                </p>
                <p class="mt-n3">
                  <b>-ASUNTO:</b> {{ comunicado.asunto }}
                </p>
                <p class="mt-n3">
                  <b>-FECHA CREACIÓN:</b> {{ comunicado.created_at | formatDateTime }}
                </p>
                <p class="mt-n3" v-if="comunicado.e_envio">
                  <b>-FECHA DE ENVIO AL JUZGADO:</b>
                  {{ comunicado.e_envio.fecha_envio | formatDateTime }}
                  <span v-if="comunicado.vista_juez==1 && !comunicado.e_envio.contesto">
                    ({{ comunicado.e_envio.fecha_envio | formatDays }})
                  </span>
                </p>
                <v-row>
                  <v-col cols="6">
                    <p class="">
                      <b style="color: grey; font-size: 18px;">
                        DOCUMENTO(S) ENVIADO(S) AL JUZGADO
                      </b>
                    </p>
                    <ul
                      class="ml-2"
                      v-for="(envio, i) in comunicado.envio_documentos"
                      :key="'envio_'+i"
                    >
                      <li>
                          <!-- {{ envio.documento.nombre_original }} -->
                          <span v-if="envio.documento.leyenda">{{ envio.documento.leyenda.toUpperCase() }}</span>
                          <span v-else>{{ envio.documento.tipo_documento.nombre.toUpperCase() }}</span>

                        <v-btn
                          v-if="envio.documento.url_evidencia"
                          x-small
                          class="white--text ml-3"
                          color="blue"
                          @click="getFile(envio.documento, 'url_evidencia')"
                        >VER DOCUMENTO
                        </v-btn>
                        <v-btn
                          v-if="!envio.documento.url_evidencia"
                          x-small
                          class="white--text ml-3"
                          color="#717171"
                          @click="showDocument(envio.documento)"
                        >
                          <!-- <v-icon left class="mt-n2">
                            mdi-signature
                          </v-icon> -->
                          VER FIRMANTES
                        </v-btn>
                        <v-btn
                          v-if="comunicado.vista_juez==2"
                          x-small
                          class="white--text ml-3"
                          color="red"
                          @click="deleteFile(envio.documento)"
                        >ELIMINAR
                        </v-btn>
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="6">
                    <div v-if="comunicado.e_envio && comunicado.e_envio.contestacion">
                      <p style="color: grey; font-size: 18px;">
                        <b>DOCUMENTO DE CONTESTACIÓN</b>
                      </p>
                      <ul>
                        <li
                          class="ml-2"
                          v-for="(documento, i) in comunicado.e_envio.contestacion.documentos"
                          :key="'documento_contestacion_'+i"
                        >
                          <!-- <a style="text-decoration: underline;color: blue;font-size: 18px;"
                            @click="getFileComunicado(documento)"
                          >
                            {{ documento.nombre }}
                          </a> -->
                          <v-btn
                            x-small
                            class="white--text"
                            color="blue"
                            @click="getFileComunicado(documento)"
                          >VER DOCUMENTO
                          </v-btn>
                        </li>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <!-- PENDIENTE ENVIO -->
              <v-alert
                v-if="comunicado.vista_juez==2"
                class="text-uppercase mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
                <span class="text-uppercase" style="color:#276090">
                  Comunicado pendiente de enviar a Juzgado.
                </span>
              </v-alert>
              <!-- END PENDIENTE ENVIO -->
              <!-- ENVIADO NO-REQUERIMIENTO -->
              <v-alert
                v-if="comunicado.vista_juez==1 && comunicado.e_envio.contesto!=1 && comunicado.tipo_envio.nombre!='Requerimiento'"
                class="text-uppercase mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
                <span class="text-uppercase" style="color:#276090">
                  Comunicado enviado a Juzgado con éxito!
                </span>
              </v-alert>
              <!-- END ENVIADO NO-REQUERIMIENTO -->
              <!-- ENVIADO REQUERIMIENTO -->
              <v-alert
                v-if="comunicado.vista_juez==1 && !comunicado.e_envio.contesto  && comunicado.tipo_envio.nombre=='Requerimiento'"
                class="text-uppercase mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
                <v-row align="center">
                  <v-col class="grow">
                    <span class="text-uppercase" style="color:#276090">
                      Comunicado enviado a Juzgado con éxito!
                    </span>
                  </v-col>
                  <v-col class="shrink">
                    <v-btn
                      small
                      class="white--text"
                      color="green"
                      @click="accionesComunicado(comunicado, 'contesto_otro_medio')"
                    >CONTESTÓ POR OTRO MEDIO</v-btn>
                  </v-col>
                  <v-col class="shrink">
                    <v-btn
                      small
                      class="white--text"
                      color="red"
                      @click="accionesComunicado(comunicado, 'no_contesto')"
                    >MARCAR COMO "NO CONTESTÓ"</v-btn>
                  </v-col>
                </v-row>
              </v-alert>
              <!-- ENVIADO NO CONTESTADO -->
              <v-alert
                v-if="comunicado.contesto==2"
                class="text-uppercase mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
              <span class="text-uppercase" style="color:#276090">
                Comunicado no contestado por Juzgado.
              </span>
              </v-alert>
              <!-- ENVIADO NO CONTESTADO -->
              <!-- CONTESTADA Y SUBSANADA-->
              <v-alert
                v-if="comunicado.vista_juez==1 &&
                      comunicado.e_envio.contesto==1 &&
                      comunicado.status!=2"
                class="text-uppercase mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
                <v-row align="center">
                  <v-col class="grow"
                    v-if="!comunicado.contesto && comunicado.e_envio.contesto==1"
                  >
                    <span class="text-uppercase" style="color:#276090">
                     Comunicado contestado por Juzgado.
                    </span>
                  </v-col>
                  <v-col class="grow"
                    v-if="comunicado.contesto &&
                          comunicado.e_envio.contesto==1 &&
                          comunicado.status==1"
                  >
                    <span class="text-uppercase" style="color:#276090">
                     Comunicado contestado y aceptado correctamente.
                   </span>
                  </v-col>
                  <v-col class="shrink"
                    v-if="!comunicado.contesto && comunicado.e_envio.contesto==1"
                  >
                    <v-btn
                      small
                      class="white--text"
                      color="blue dark-1"
                      @click="accionesComunicado(comunicado, 'recibir_aceptar')"
                    >RECIBIR Y SUBSANÓ</v-btn>
                  </v-col>
                  <v-col class="shrink"
                    v-if="!comunicado.contesto && comunicado.e_envio.contesto==1"
                  >
                    <v-btn
                      small
                      class="white--text"
                      color="orange dark-1"
                      @click="accionesComunicado(comunicado, 'recibir_no_aceptar')"
                    >RECIBIR Y NO SUBSANÓ</v-btn>
                  </v-col>
                </v-row>
              </v-alert>
              <!-- END CONTESTADA Y SUBSANADA -->
              <!-- CONTESTADA Y NO SUBSANADA-->
              <v-alert
                v-if="comunicado.vista_juez==1 &&
                      comunicado.e_envio.contesto==1 &&
                      comunicado.status==2"
                class="mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
              <span class="text-uppercase" style="color:#276090">
                Comunicado contestado y NO SUBSANADO.
              </span>
              </v-alert>
              <!-- END CONTESTADA Y NO SUBSANADA -->
              <!-- CONTESTADA POR OTRO MEDIO -->
              <v-alert
                v-if="comunicado.vista_juez==1 &&
                      comunicado.e_envio.contesto==4 &&
                      comunicado.status==1"
                class="mr-4 ml-4 mt-4 font-weight-bold"
                icon="mdi-information-outline"
                color="#cda652"
                border="left"
                elevation="2"
                colored-border
                dense
                prominent
              >
              <span class="text-uppercase" style="color:#276090">
                Comunicado contestado por otro medio.
              </span>
              </v-alert>
              <!-- END CONTESTADA POR OTRO MEDIO -->
              <v-divider></v-divider>
            </div>
            <h2 v-if="listComunicados.length == 0"
              class="font-weight-bold mt-3"
              style="color: grey;
              font-size: 15px;"
              align="center">
                No hay Comunicados Registrados
            </h2>
          </v-list>
        </v-card>
      </v-col>
      <hr><br>
      <v-row
        align="center"
        justify="space-around"
      >
        <v-btn
          class="mb-3 mt-3"
          tile
          color="success"
          @click="clickAddComunicado()"
          dense
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          AGREGAR COMUNICADO
        </v-btn>
      </v-row>
    </v-card>

    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";
  import ApelacionElectronica from "@/components/ApelacionElectronica";

  export default {
    components: {
      ApelacionElectronica
    },
    props: {
      source: String
    },
    data() {
      return {
        indexLoader:-1,
        apelacion_id:'',
        listComunicados: [],
        progress: false,
        eApelacion:"ApelacionElectronica",
        currentApelacion:{},
      };
    },
    computed: {
      ...mapGetters(['currentUser'])
    },
    created() {
      localStorage.removeItem("currentEnvio");
      this.apelacion_id = JSON.parse(localStorage.getItem('currentApelacion'));
      this.showApelacion()
      this.getComunicados();
    },
    methods: {
      accionesComunicado(comunicado, accion){
        if (accion == 'no_contesto') {
          this.titleSwal =  '¿Confirma marcar como NO CONTESTÓ?'
          this.textSwal= "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>"
          this.url = "/no-contesto"
          this.responseTextSwal = "La Contestación se ha marcado como NO CONTESTÓ!"
        }
        if (accion == 'recibir_aceptar') {
          this.titleSwal =  '¿Confirma Recibir y Aceptar Contestación?'
          this.textSwal= "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>"
          this.url = "/aceptar"
          this.responseTextSwal = "Contestación aceptada con éxito!"
        }
        if (accion == 'contesto_otro_medio') {
          this.titleSwal =  '¿Confirma Recibió Contestacion por Otro Medio?'
          this.textSwal= "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>"
          this.url = "/contesto-otro-medio"
          this.responseTextSwal = "Contestación aceptada con éxito!"
        }
        if (accion == 'recibir_no_aceptar') {
          this.titleSwal =  '¿Confirma Recibir Comunicado y Marcar como No Subsanado?'
          this.textSwal= "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>"
          this.url = "/no-subsano"
          this.responseTextSwal = "Contestación aceptada y marcada como No Subsanada"
        }
        Swal.fire({
          title: this.titleSwal,
          html: this.textSwal,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("UPDATE_APELACION", { url: this.url,
              data:{
                e_apelacion_id: comunicado.e_apelacion_id,
                e_envio_id: comunicado.e_envio_id,
                apelacion_id: comunicado.apelacion_id,
                envio_id: comunicado.id,
              }
            }).then(response => {
              Swal.fire({
                icon: 'success',
                title: this.responseTextSwal,
                confirmButtonText: "Aceptar"
              })
              this.getComunicados()
            }).catch(err => {
              Swal.fire({
                icon: 'error',
                title: err.response.data.message,
                confirmButtonText: "Aceptar"
              })
              this.getComunicados()
              console.log(err);
            });
          }
        })
      },
      clickAddComunicado(){
        const check_comunicados = new Promise((resolve,reject) => {
          this.faltantes_vista_juez = this.listComunicados.find( comunicado =>
            comunicado.debe_contestar == 1 && comunicado.vista_juez ==2
          );
          this.faltantes_no_contesto = this.listComunicados.find( comunicado =>
            comunicado.debe_contestar == 1 && !comunicado.contesto
          );
          if (this.faltantes_vista_juez) {
            reject('faltantes_vista_juez')
          }
          else if (this.faltantes_no_contesto) {
            reject('faltantes_contesto')
          }
          else {
            resolve('completo')
          }
        });

        check_comunicados.then((result) => {
          this.$router.push({ name:'ComunicadoCreate' })
        }).catch(err => {
          console.log(err)
          if (err == 'faltantes_contesto') {
            this.titleSwal = "Para agregar un nuevo comunicado, es necesario que el juzgado le de contestación, marcar el comunicado como 'NO CONTESTÓ' o 'RECIBIR' la contestación."
          }
          if (err == 'faltantes_vista_juez') {
            this.titleSwal = 'Favor de dar Vista al Juez de los comunicados de Requerimiento ya generados.'
          }
          Swal.fire({
            icon: 'error',
            title: this.titleSwal,
            confirmButtonText: "Aceptar",
          })
        });
      },
      clickDarVista(comunicado){
        const check_evidencias = new Promise((resolve,reject) => {
          this.resultado = comunicado.envio_documentos.find( envio =>
            envio.documento.url_evidencia == null
          );
          if (!this.resultado) {
            resolve('completo')
          } else {
            reject('no_completo')
          }
        });

        check_evidencias.then((result) => {
          this.saveEnvioAE(comunicado)
        }).catch(err => {
          if (err == 'no_completo') {
            this.indexLoader=-1
            Swal.fire({
              icon: 'error',
              title: 'Para dar Vista al Juez, se deberá firmar y generar Evidencia Criptográfica de cada uno de los documentos del comunicado.',
              confirmButtonText: "Aceptar",
            })
          }
        });
      },
      saveEnvioAE(comunicado){
        this.textSwal = ''
        if (comunicado.tipo_envio.nombre == "Requerimiento") {
          this.textSwal="<span style='color:red; font-weight: 800;'>NOTA: Una vez enviado el comunicado, no se podrá modificar y el toca quedará en estatus 'Para Regularizar'.</span>"
        }
        Swal.fire({
          title: '¿Desea enviar al Juzgado?',
          html: this.textSwal,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("SAVE_ENVIO_AE",  {
              url: '/vista-juez',
              data: comunicado
            }).then(response => {
              Swal.fire({
                icon: 'success',
                title: 'Se ha enviado con exito el comunicado!!!',
                confirmButtonText: "Aceptar"
              })
              this.getComunicados()
              this.indexLoader=-1
              this.showApelacion()
            }).catch(err => {
              console.log(err);
            });
          } else {
            this.indexLoader=-1
          }
        })
      },
      addComunicado(item){
        localStorage.setItem("currentEnvio", JSON.stringify( item ));
        this.$router.push({ name:'ComunicadoCreate' })
      },
      getComunicados(){
        this.$store.dispatch("GET_DOCUMENTOS",  {
          url: '/comunicados/' + this.apelacion_id
        }).then(response => {
          this.listComunicados = response.data.data.envios
        }).catch(err => {
          console.log(err);
        });
      },
      showDocument(item){
        localStorage.setItem("currentDocument", JSON.stringify( item.id ));
        this.$router.push({ name:'DocumentoFirma' })
      },
      getFile(item, campo){
        var url = "/documento/"+ item.id +"/file"
        var data = {
          campo: campo
        }
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: url, data: data  }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
        }).catch(err => {
          console.log(err);
          this.progress = false
        });
      },
      getFileComunicado(item){
        this.data_file = { url_documento: item.url }
        this.progress = true
        this.$store.dispatch("GET_DOCUMENTO", { url: '/apelacion/show-contestacion', data: this.data_file })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          }).catch(err => {
            this.progress = false
            console.log(err);
          });
      },
      deleteFile(item){
        Swal.fire({
          title: '¿Confirma eliminar el documento ?',
          html: "<span style='color:red; font-weight: 800;'>NOTA: Esta acción no se puede deshacer.</span>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store.dispatch("DELETE_DOCUMENTO",{
              url: "/envio-documento/" + item.id + '/delete'
            }).then((response) => {
              this.loadingEliminarDoc = false
              if (response.data.status=='ok') {
                Swal.fire({
                  icon: 'success',
                  title: 'El documento ha sido eliminado',
                  confirmButtonText: "Aceptar",
                })
              }
              this.getComunicados()
              // this.$router.push('/bandeja')
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      deleteComunicado(comunicado){
        Swal.fire({
          title: '¿Desea eliminar el Comunicado?',
          html: "<span style='color:red; font-weight: 800;'>NOTA: Esta acción no se puede deshacer.</span>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store.dispatch("DELETE_DOCUMENTO",{
              url: "/comunicados/" + comunicado.id + '/delete'
            }).then((response) => {
              this.loadingEliminarDoc = false
              if (response.data.status=='ok') {
                Swal.fire({
                  icon: 'success',
                  title: 'Comunicado eliminado correctamente',
                  confirmButtonText: "Aceptar",
                })
              }
              this.getComunicados()
              // this.$router.push('/bandeja')
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      showApelacion(){
        this.currentApelacion = {}
        this.$store.dispatch("SHOW_APELACION", {
          url:"/apelacion/"+ this.apelacion_id,
          // url:"/apelacion/"+ this.currentApelacion.id,
        } )
        .then((response) => {
          this.currentApelacion = response.data.data.apelacion
          // this.resolucion_proyecto = response.data.data.resolucion_proyecto
        // this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
    }
  };
</script>
